
import { Box, Grid } from "@chakra-ui/react";

import COXMultiVar from "views/admin/analysisSurvival/components/COXMultiVar"
import COXUniVar from "views/admin/analysisSurvival/components/COXUniVar"
import OverallSurvival from "views/admin/analysisSurvival/components/OverallSurvival"
import SampleProfile from "views/admin/analysisSurvival/components/SampleProfile"
import TDMModel from "views/admin/analysisSurvival/components/TDMModel"
import TDUModel from "views/admin/analysisSurvival/components/TDUModel"

import {
    columnsDataDevelopment,
    columnsDataCheck,
    columnsDataColumns,
    columnsDataComplex,
} from "views/admin/dataTables/variables/columnsData";
import tableDataDevelopment from "views/admin/dataTables/variables/tableDataDevelopment.json";
import tableDataCheck from "views/admin/dataTables/variables/tableDataCheck.json";
import tableDataColumns from "views/admin/dataTables/variables/tableDataColumns.json";
import tableDataComplex from "views/admin/dataTables/variables/tableDataComplex.json";

import Select from "react-select";
import React, { useState, useEffect } from 'react';

const options = [
    // { value: 'BRC', label: 'BRC' },
    // { value: 'CCRCC', label: 'CCRCC' },
    // { value: 'CRC', label: 'CRC' },
    // { value: 'GBM', label: 'BRC' },
    // { value: 'HNSCC', label: 'HNSCC' },
    // { value: 'LSCC', label: 'LSCC' },
    // { value: 'LUAD', label: 'LUAD' },
    // { value: 'OVC', label: 'OVC' },
    { value: 'PDAC', label: 'PDAC' },
    // { value: 'UCEC', label: 'UCEC' },
];

export default function Settings() {
    const [selectedOption, setSelectedOption] = useState({ value: 'PDAC', label: 'PDAC' });  // Maintain the state for the selected option

    const handleChange = (option) => {
        setSelectedOption(option);  // Update the state when an option is selected
    };

    // Chakra Color Mode
    return (
        <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
            <Box mb="4">
                <Select options={options} onChange={handleChange} defaultValue={{ value: 'PDAC', label: 'PDAC' }} />
            </Box>
            <Grid
                templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(3, 1fr)", lg: "repeat(3, 1fr)" }}
                gap={{ base: "20px", xl: "20px" }}
                mb="20px"
            >
                <SampleProfile
                    selectedOption={selectedOption}
                />
                <COXUniVar
                    selectedOption={selectedOption}
                   
                />
                <COXMultiVar
                    selectedOption={selectedOption}
                  
                />
            </Grid>
            <Grid
                templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(3, 1fr)", lg: "repeat(3, 1fr)" }}
                gap={{ base: "20px", xl: "20px" }}
            >
                <OverallSurvival
                    selectedOption={selectedOption}

                />
                <TDUModel
                    selectedOption={selectedOption}
                />
                <TDMModel
                    selectedOption={selectedOption}
                />
            </Grid>

        </Box>
    );
}
